import { Tab, Tabs as ChakraTabs, TabList, TabPanels } from '@chakra-ui/react';
import { SyncTabInstancesContext } from '@context/sync-tab-instances';
import { ReactElement, useContext, useState } from 'react';

export function Tabs({
  type,
  items,
  children
}: {
  type: string;
  items: string[];
  children: ReactElement;
}) {
  const { getActiveTab, setActiveTab } = useContext(SyncTabInstancesContext);
  const [localActiveTab, setLocalActiveTab] = useState(0);

  const activeTabName = getActiveTab(type);

  let activeTab;
  if (!type) {
    activeTab = localActiveTab;
  } else {
    const activeTabIndex = items.indexOf(activeTabName);
    if (activeTabIndex === -1) {
      activeTab = 0;
    } else {
      activeTab = activeTabIndex;
    }
  }

  function handleChange(index: number) {
    if (!type) {
      setLocalActiveTab(index);
    }
    const title = items[index];
    setActiveTab(type, title);
  }

  return (
    <ChakraTabs
      pt={6}
      onChange={index => handleChange(index)}
      index={activeTab}
    >
      <TabList mb={4}>
        {items.map((title: string) => {
          return <Tab key={title}>{title}</Tab>;
        })}
      </TabList>
      <TabPanels>{children}</TabPanels>
    </ChakraTabs>
  );
}
